export type LoadingType = 'idle' | 'pending' | 'succeeded' | 'failed'
export const loadingObj: { loading: LoadingType } = {
    loading: 'idle'
}